import { render, staticRenderFns, recyclableRender, components } from "./uni-data-checkbox.vue?vue&type=template&id=84d5d996&"
var renderjs
import script from "./uni-data-checkbox.vue?vue&type=script&lang=js&"
export * from "./uni-data-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./uni-data-checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-data-checkbox/components/uni-data-checkbox/uni-data-checkbox.vue"
export default component.exports